import { Button, Col, Row, Progress, message } from 'antd';
import React, { useState } from 'react';
import {
  convertDateToTimezone,
  convertTimeToTimezone,
  formatDateTo,
  getSubCategoryName,
} from '../../helpers/functions';
import { ReviewModal } from './modal/reviewModal';
import { defaultAvatarImg } from '../../helpers/constant';
import useResponsive from '../../hooks/useBreakpoint';
import { CommentOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { postRequest } from '../../helpers/apiCall';
import { set } from 'lodash';

const RequestHistoryCard = props => {
  const [showModal, setShowModal] = useState(false);
  const breakpoint = useResponsive();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const showReviewModal = () => {
    if (!props?.question_review?.length) {
      setShowModal(true);
    } else {
      message.error(`Review for request id #${props?.id} is already registered.`);
    }
  };
  const createNewProfessionalRequest = async () => {
   try {
    setLoading(true);
    const resp = await postRequest('newquestionfromoldquestion', {
      question_id: props?.id
    })
    if(resp?.data?.success){
      navigate(`/my-request/${resp?.data?.question_id}`);
    }else{
      message.error(resp?.message);
    }
    setLoading(false);
   } catch (error) {
        setLoading(false);
   }
  };
  return (
    <div
      className={`requests-history-accounting ${props?.list ? 'custom-request-card' : ''}`}
      onClick={props?.onRequestClick}
         style={{backgroundColor : props?.question_type?.name === 'Professional Service' && "rgb(204,239,252)" || props?.question_type?.name === 'Consultation' && "#ECECEC"}}
    >
       
      <Row className="requests-history-accounting-row">
        <Col
          className="requests-accounting-col"
          onClick={props.isClickable ? props.onRequestClick : undefined}
          style={{ cursor: props.isClickable && 'pointer' }}
          xs={6}
          sm={6}
          md={6}
          lg={4}
          xl={4}
          xxl={4}
        >
          <Row>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              xxl={24}
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
              <img
                src={props.expert_meta?.avatar || defaultAvatarImg}
                alt="avatar"
                height={'80px'}
                width={'80px'}
                style={{ borderRadius: '50%' }}
                loading="lazy"
              />
            </Col>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              xxl={24}
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
              <div style={{ marginTop: '10px', fontWeight: 'bold' }}>
                {props?.expert?.first_name + ' ' + props?.expert?.last_name?.[0] + '.'}
              </div>
            </Col>
          </Row>
        </Col>

        <Col
          xs={18}
          sm={18}
          md={18}
          lg={20}
          xl={20}
          xxl={20}
          style={{ padding: breakpoint === 'xs' && '1rem' }}
        >
          <Row >
            <Col
              onClick={props.isClickable ? props.onRequestClick : undefined}
              style={{ cursor: 'pointer' }}
              xs={12}
              sm={8}
              md={8}
              lg={4}
              xl={4}
              xxl={4}
            >
              <div className="id pr-4">
                <div className="p-title">ID #{props?.id ? props?.id : '-'}</div>
                <h3 className="title">
                  {props?.category?.name ? props?.category?.name : 'Not Selected'}
                </h3>
                <p className="title-i">
                  <i>{getSubCategoryName(props)}</i>
                </p>
              </div>
            </Col>
            <Col xs={12} sm={8} md={8} lg={5} xl={5} xxl={5} className="">
              <div className="date">
                <div className="p-title">Request Type</div>
                <h3 className="title-date title">
                  {props?.question_type?.name ? props?.question_type?.name?.split(' ')[0] : 'Not Selected'}
                </h3>
                {
                  props?.question_type?.name === 'Professional Service' && <h3>Service</h3>
                }
                
              </div>
            </Col>
            <Col xs={12} sm={8} md={8} lg={5} xl={5} xxl={5} className="">
              <div className="date">
                <div className="p-title">Request date</div>
                <h3 className="title-date title">{convertDateToTimezone(props?.created_at)}</h3>
                <h3 className="title-date title">{convertTimeToTimezone(props?.created_at)}</h3>
              </div>
            </Col>
            <Col  xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
              <div className="date">
                <div className="p-title" style={{ color: 'green' }}>
                  Completed on
                </div>
                <h3 className="title-date title" style={{ color: 'green' }}>
                  {props?.status?.created_at ? (
                    <>
                      {convertDateToTimezone(props?.status?.created_at)} <br />{' '}
                      {convertTimeToTimezone(props?.status?.created_at)}
                    </>
                  ) : (
                    '-'
                  )}
                </h3>
              </div>
            </Col>

            {!props?.list && (
              <Col style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'end' }}  xs={24} sm={12} md={12} lg={5} xl={5} xxl={5}>
              
                

                    {props.question_type.id == 1 && (
                      <Button
                        className="expert-request-button"
                        onClick={() => {
                         createNewProfessionalRequest();
                        }}
                        type="primary"
                        style={{ width: 'auto',marginBottom: '10px' }}
                        size='large'
                        loading={loading}
                      >
                        Work with{' '}
                        {props?.expert?.first_name + ' ' + props?.expert?.last_name?.[0] + '.'}
                      </Button>
                    )}

                    <Button
                      className="expert-request-button"
                      onClick={showReviewModal}
                      type="primary"
                      size='large'
                    >
                      Mark a review
                    </Button>
                 
               
              </Col>
            )}
          </Row>
        </Col>
      </Row>

      <ReviewModal
        visible={showModal}
        setShowModal={setShowModal}
        expertId={props?.expert?.id}
        questionId={props?.id}
        questionStatus={props?.status?.id > 9 ? 'deactive' : 'active'}
        rawData={props}
      />
    </div>
  );
};

export default RequestHistoryCard;
